import {Component, EventEmitter, OnInit, Output, Input, OnChanges} from '@angular/core';
import {FormGroup, FormBuilder} from '@angular/forms';
import {ValidationCodeVm} from 'src/app/view-model/validation-code/validation-code.vm';
import {FormErrorValidatorService} from '../../services/form-error-validator.service';

@Component({
  selector: 'app-select-email',
  templateUrl: './select-email.component.html',
  styleUrls: ['./select-email.component.scss'],
})
export class SelectEmailComponent implements OnInit, OnChanges {
  @Input() idPrefix = '';
  @Input() listEmail;
  @Input() isSignUpForm;
  @Input() isModal = false;
  @Input() openModal = false;
  @Input() showTitle = false;
  @Output() loggedIn = new EventEmitter<any>();
  @Output() selectMethod = new EventEmitter<any>();
  @Output() validateCode = new EventEmitter<any>();
  @Output() openValidateCodeModal = new EventEmitter<any>();
  @Output() validateCodeMode = new EventEmitter<any>();
  @Output() selectEmail = new EventEmitter<any>();
  customer;
  enableValidateCode = false;
  options = [];
  smsValidationForm: FormGroup;
  idCustomer;
  message;
  reSendDisabled = true;
  isFirstReSend = true;
  isSecondReSend = false;
  isLoading = false;
  disableButton = true;
  isTokenValid = false;
  showWhatsApp = false;
  smsToken = '';
  smsTokenAlgolia = '';
  error = {
    token: '',
  };
  errorObj: any;
  countDownCounter = 0;
  hideReSend;
  sendAlgolia = false;
  indexMessage;
  tokenFTD;

  constructor(private formBuilder: FormBuilder,
              private fev: FormErrorValidatorService,
              private vm: ValidationCodeVm) {}

  init() {
    this.enableValidateCode = false;
    this.listEmail.forEach(emailCustomer => {
      emailCustomer.list.forEach(option => {
        if (option.type === 'email') {
          this.options.push(option.data)
        }
      })
    });
  }

  onSuccess(event) {
    this.loggedIn.emit(event);
  }

  selectOption(option) {
    this.listEmail.forEach(emailCustomer => {
      emailCustomer.list.forEach(optionSelect => {
        if (optionSelect.type === 'email' && option === optionSelect.data) {
          this.customer = emailCustomer;
          this.idCustomer = emailCustomer.idCustomer;
        }
      })
    });
    this.disableButton = false;
  }

  onValidateCode(event) {
    this.validateCode.emit(event);
  }

  openValidateCode() {
    this.isLoading = true;
    this.vm.sendMessage('phone', this.idCustomer).subscribe(() => {
      if (this.isModal) {
        this.enableValidateCode = true;
        this.validateCodeMode.emit(true);
        return;
      }
      this.openValidateCodeModal.emit(true);
      this.isLoading = false;
    });
  }

  ngOnInit() {
    this.init();
  }

  ngOnChanges(changes): void {
    this.idCustomer = changes && changes.listCustomer ? changes.listCustomer.currentValue[0].idCustomer : '';
  }
}